// @ts-ignore
const crypto = window.crypto;
const array = new Uint32Array(1);

export const getRandomId = () => {
  return crypto.getRandomValues(array)[0].toString(36);
};
